// frontend/nidoux/react-functions/src/components/Terms.js
import React from 'react';
import '../styles/LoginScreen.css';
import { ReactComponent as Logo } from '../assets/LogoNidouxSVG.svg';
import LanguageSwitcher from './shared/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { useBodyBackground } from '../hooks/useBodyBackground';

function TermsAndConditions({ onBack }) {
  useBodyBackground('#ffffff');
  const { t } = useTranslation();

  // ✅ Detect if we're on public terms page
  const isPublicPage = window.location.pathname === '/terms';

  return (
    <div className="login-page" style={{ 
      justifyContent: 'flex-start', 
      overflowY: 'auto',
      paddingTop: '40px',
      paddingBottom: '40px'
    }}>
      <div className="language-switcher-wrapper">
        <LanguageSwitcher />
      </div>

      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <div className="logo-container" style={{ marginBottom: '20px' }}>
          <Logo className="logo-svg" style={{ height: '80px' }} />
        </div>
        <h1 style={{ 
          fontSize: '28px', 
          fontWeight: '700', 
          color: '#2d3748',
          marginBottom: '8px'
        }}>
          {t('terms.title')}
        </h1>
        <p style={{ 
          color: '#718096', 
          fontSize: '14px',
          marginBottom: '20px'
        }}>
          {t('terms.lastUpdated')}: {t('terms.updateDate')}
        </p>
      </div>

      <div style={{ 
        color: '#4a5568', 
        lineHeight: '1.8',
        fontSize: '15px'
      }}>
        {/* Introduction */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.intro.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.intro.paragraph1')}
          </p>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.intro.paragraph2')}
          </p>
        </section>

        {/* Company Information */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.company.title')}
          </h2>
          <div style={{ 
            background: '#f7fafc', 
            padding: '16px', 
            borderRadius: '8px',
            borderLeft: '4px solid #667eea'
          }}>
            <p style={{ margin: '0 0 8px 0', fontWeight: '600' }}>planifyit GmbH</p>
            <p style={{ margin: '0 0 4px 0' }}>CHE-231.157.006</p>
            <p style={{ margin: '0 0 4px 0' }}>Av. de Tivoli 3</p>
            <p style={{ margin: '0 0 4px 0' }}>1700 Fribourg, Switzerland</p>
            <p style={{ margin: '0' }}>contact@planifyit.com</p>
          </div>
        </section>

        {/* Data Storage Agreement */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.dataStorage.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.dataStorage.paragraph1')}
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '12px' }}>
            <li style={{ marginBottom: '8px' }}>{t('terms.dataStorage.item1')}</li>
            <li style={{ marginBottom: '8px' }}>{t('terms.dataStorage.item2')}</li>
            <li style={{ marginBottom: '8px' }}>{t('terms.dataStorage.item3')}</li>
            <li style={{ marginBottom: '8px' }}>{t('terms.dataStorage.item4')}</li>
            <li style={{ marginBottom: '8px' }}>{t('terms.dataStorage.item5')}</li>
          </ul>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.dataStorage.paragraph2')}
          </p>
        </section>

        {/* Use of Service */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.useOfService.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.useOfService.paragraph1')}
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '12px' }}>
            <li style={{ marginBottom: '8px' }}>{t('terms.useOfService.item1')}</li>
            <li style={{ marginBottom: '8px' }}>{t('terms.useOfService.item2')}</li>
            <li style={{ marginBottom: '8px' }}>{t('terms.useOfService.item3')}</li>
          </ul>
        </section>

        {/* User Accounts */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.userAccounts.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.userAccounts.paragraph1')}
          </p>
        </section>

        {/* Privacy and Data Protection */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.privacy.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.privacy.paragraph1')}
          </p>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.privacy.paragraph2')}
          </p>
        </section>

        {/* Intellectual Property */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.intellectualProperty.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.intellectualProperty.paragraph1')}
          </p>
        </section>

        {/* Limitation of Liability */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.liability.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.liability.paragraph1')}
          </p>
        </section>

        {/* Changes to Terms */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.changes.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.changes.paragraph1')}
          </p>
        </section>

        {/* Contact */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#2d3748',
            marginBottom: '12px'
          }}>
            {t('terms.contact.title')}
          </h2>
          <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
            {t('terms.contact.paragraph1')}
          </p>
        </section>
      </div>

      {/* Footer */}
      <div style={{
        marginTop: '40px',
        paddingTop: '20px',
        borderTop: '1px solid #e2e8f0',
        textAlign: 'center'
      }}>
        <button 
          onClick={onBack} 
          className="submit-button"
          style={{ marginBottom: '15px' }}
        >
          {/* ✅ Different text for public vs internal */}
          ← {isPublicPage ? t('terms.backToHome') : t('terms.backToLogin')}
        </button>
        <p className="powered-by" style={{ color: '#94a3b8' }}>
          {t('login.poweredBy')}
        </p>
      </div>
    </div>
  );
}

export default TermsAndConditions;